import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AlertConfig, LocationManager } from '../types'
import Colors from '../../constants/Colors'

export const DEFAULT_CHECKOUT_CONFIG = {
	kiosk: {
		requiredFields: {
			name: true,
			phoneNumber: false,
			email: false,
		},
	},
	guest: {
		requiredFields: {
			name: true,
			phoneNumber: false,
			email: false,
		},
	},
	webMob: {
		requiredFields: {
			name: true,
			phoneNumber: true,
			email: true,
		},
	},
}

// not persisted
// set once in RetrieveData and then not changed
const initialState = {
	isSingleBrand: false,
	showItemAddedAnimation: true,
	posLoyaltyEnabled: false,
	dineInEnabled: false,
	usesTableNumbers: false,
	posProvider: '',
	paymentProvider: '',
	pickupPointsEnabled: false,
	allowOrdersOutsideOrgHours: false,
	outsideOrgHoursOrderType: 'multi', //or 'single'
	delivery: {
		freeDeliveryMultiplier: -1,
		isSandbox: false,
		orgCoverage: -1,
		orgCoverageType: '',
		actionIfUndeliverable: 'dispose',
		pickupInstructions: '',
		minSpend: -1,
		freeDeliveryMinimumOrder: null,
		freeDeliveryDistanceThreshold: null,
	},
	deliveryEnabled: false,
	deliveryOrgReceivedPercent: 0,
	localTimezone: '',
	scheduleTimeInterval: 15,
	scheduleDaysAhead: 14,
	serviceFee: 0,
	serviceFeeGST: 0,
	serviceFeePST: 0,
	orgDeliveryCoverageType: '',
	orgDeliveryCoverage: 0,
	deliveryIsSandbox: false,
	isSandbox: false,
	webOrdersEnabled: true,
	checkoutConfig: DEFAULT_CHECKOUT_CONFIG,
	enableGiftCard: false,
	alertConfig: {
		visible: false,
		title: '',
		body: '',
		buttonA: '',
		buttonB: null,
		onPressA: null,
		onPressB: null,
		showExitIcon: false,
		onPressExit: null,
		boldButton: null,
		colorA: '',
		colorB: '',
	},
	privacyPolicy: {
		emailAddress: null,
	},
	appDisplayOptions: {
		homeLayout: '',
		showRestaurants: false,
		showCategories: false,
		showBrands: false,
		showLoyalty: false,
		showCuisines: false,
		showDisclaimerText: false,
		randomizeRestaurantDisplay: false,
		showTermsOfUse: false,
		banner: {
			mobile: null,
			desktop: null,
			backgroundColor: null,
		},
		kiosk: {
			startScreenImage: null,
			showPromoImages: true,
		},
		showTipRestaurant: false,
		styles: {
			backgroundColor: '#f8f8f8',
			buttonAlternateColor: Colors.greyscale[2],
			hasBoxShadow: true,
		},
		receipt: {
			customText: null,
		},
	},
	address: null,
	customTipOptions: {
		delivery: null,
		pickup: null,
		kiosk: null,
	},
	country: 'CA',
	seo: {
		metaDescription: null,
		metaTitle: null,
	},
}

type StateTypes = typeof initialState

const slice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		setStates: (state, action: PayloadAction<Partial<StateTypes>>) => {
			Object.assign(state, action.payload)
		},
		showCustomAlert(state, action) {
			const {
				title,
				body,
				buttonA,
				buttonB = null,
				onPressA = () => {},
				onPressB = () => {},
				showExitIcon = false,
				onPressExit = () => {},
				boldButton = null,
				colorA = '',
				colorB = '',
			} = action.payload

			state.alertConfig = {
				visible: true,
				title,
				body,
				buttonA,
				buttonB,
				onPressA,
				onPressB,
				showExitIcon,
				onPressExit,
				boldButton,
				colorA,
				colorB,
			}
		},

		hideCustomAlert(state) {
			state.alertConfig.visible = false
		},
	},
})

const { setStates, showCustomAlert, hideCustomAlert } = slice.actions

export const setSettingsState = (updates: Partial<StateTypes>) => setStates(updates)
export const showAlert = (updates: AlertConfig) => showCustomAlert(updates)
export const hideAlert = () => hideCustomAlert()

export default slice.reducer
